import React, { useEffect, useState } from "react";
import { Plus, Users, Trash2, Loader2, Shield } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Badge } from "../components/ui/badge";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { api } from "../api";
import { useAuth } from "../context/AuthContext";
import { useToast } from "../hooks/use-toast";

export default function Team() {
  const { user } = useAuth();
  const { toast } = useToast();
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [creating, setCreating] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [busy, setBusy] = useState(false);
  const isOwner = user?.role === "owner";

  const load = async () => { setLoading(true); try { const { data } = await api.staff(); setStaff(data); } finally { setLoading(false); } };
  useEffect(() => { load(); }, []);

  const add = async () => {
    setBusy(true);
    try { await api.addStaff(form); toast({ title: "Collaboratore aggiunto" }); setCreating(false); setForm({ name: "", email: "", password: "" }); load(); }
    catch (e) { toast({ title: "Errore", description: e?.response?.data?.detail, variant: "destructive" }); }
    finally { setBusy(false); }
  };
  const del = async (s) => { await api.delStaff(s.id); toast({ title: "Collaboratore rimosso" }); load(); };

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div><h1 className="font-display text-2xl md:text-3xl font-extrabold">Team</h1><p className="text-muted-foreground mt-1">Proprietario e collaboratori della tua attività.</p></div>
        {isOwner && <Button className="btn-grad text-white font-semibold gap-2" onClick={() => setCreating(true)}><Plus className="h-4 w-4" /> Collaboratore</Button>}
      </div>

      {loading ? <p className="text-muted-foreground">Caricamento…</p> : (
        <div className="rounded-2xl border border-border bg-white card-shadow divide-y divide-border">
          {staff.map((s) => (
            <div key={s.id} className="flex items-center gap-4 p-4">
              <span className="flex h-11 w-11 items-center justify-center rounded-full bg-muted font-bold shrink-0">{(s.name || s.email)[0].toUpperCase()}</span>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2"><p className="font-semibold truncate">{s.name}</p>
                  <Badge variant="secondary" className="text-[10px] gap-1">{s.role === "owner" ? <><Shield className="h-3 w-3" /> Proprietario</> : "Collaboratore"}</Badge>
                </div>
                <p className="text-xs text-muted-foreground truncate">{s.email}</p>
              </div>
              {isOwner && s.role !== "owner" && <button onClick={() => del(s)} className="text-muted-foreground hover:text-destructive"><Trash2 className="h-4 w-4" /></button>}
            </div>
          ))}
        </div>
      )}

      <Dialog open={creating} onOpenChange={setCreating}>
        <DialogContent className="max-w-sm">
          <DialogHeader><DialogTitle>Nuovo collaboratore</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label className="text-xs text-muted-foreground">Nome</Label><Input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="h-10 mt-1" /></div>
            <div><Label className="text-xs text-muted-foreground">Email</Label><Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="h-10 mt-1" /></div>
            <div><Label className="text-xs text-muted-foreground">Password iniziale</Label><Input value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className="h-10 mt-1" placeholder="min 6 caratteri" /></div>
          </div>
          <DialogFooter><Button variant="outline" onClick={() => setCreating(false)}>Annulla</Button><Button className="btn-grad text-white font-semibold" onClick={add} disabled={busy}>{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Aggiungi"}</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
